import { useState, useCallback } from "react";

/**
 * Prevents double-submit by tracking an inflight state and short-circuiting
 * any concurrent calls. Use for buttons that mutate (create/post/delete).
 *
 *   const { submitting, run } = useSubmitting();
 *   <button disabled={submitting} onClick={() => run(async () => {
 *      await api.post(...);
 *   })}>
 *     {submitting ? "Saving…" : "Save"}
 *   </button>
 */
export function useSubmitting() {
  const [submitting, setSubmitting] = useState(false);

  const run = useCallback(async (fn) => {
    if (submitting) return undefined; // already inflight — drop the click
    setSubmitting(true);
    try {
      return await fn();
    } finally {
      setSubmitting(false);
    }
  }, [submitting]);

  return { submitting, run };
}
